module.exports = __webpack_public_path__ + "media/InformationsGenerales.772f5e2a.mp3";